import { render, staticRenderFns } from "./comp_ImageCard.vue?vue&type=template&id=003b479e&scoped=true&"
import script from "./comp_ImageCard.vue?vue&type=script&lang=js&"
export * from "./comp_ImageCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_ImageCard.vue?vue&type=style&index=0&id=003b479e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b479e",
  null
  
)

export default component.exports